import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../AxiosInstance/axiosInstanceJson";

export const createNotification = createAsyncThunk(
  "notification/createNotification",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/v1/admin/notification/create_Notification",
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Notification Failed");
    }
  }
);

export const getNotification = createAsyncThunk(
  "notification/getAll",
  async (
    {
      status = "",
      search = "",
      page = 1,
      limit = 20,
      startDate,
      endDate,
      paginate = true,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstance.get(
        `/v1/admin/notification/get_Notification`,
        {
          params: {
            status,
            search,
            page: Number(page),
            limit: Number(limit),
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            paginate: paginate === "true",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);
